import React from "react";
import { motion } from "framer-motion";

const LogoHome = () => {
  const logoHomeAnim = {
    initial: {
      opacity: 0,
      x: Math.floor(Math.random() * 900 * (Math.random() > 0.4 ? 1 : -1)),
      y: Math.floor(Math.random() * 1500 * (Math.random() > 0.4 ? 1 : -1)),
    },
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
    },
  };

  return (
    <motion.div
      initial="initial"
      animate="visible"
      variants={logoHomeAnim}
      transition={{ duration: 1.2 }}
      className="img-content"
    >
      <div className="logo_home">
        <img src="./assets/img/cbon-300px.png" alt="logo" />
      </div>
    </motion.div>
  );
};

export default LogoHome;
